import * as React from 'react';

function TeamsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 10.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m0 1.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8m-4.047 1.658c1.054-.59 2.504-.658 4.047-.658.79 0 1.535.015 2.2.095.662.08 1.295.23 1.84.528a2.97 2.97 0 0 1 1.302 1.394c.284.613.408 1.357.408 2.233v3.25a.75.75 0 0 1-.75.75h-10a.75.75 0 0 1-.75-.75v-3.25c0-.858.124-1.591.41-2.2a3.03 3.03 0 0 1 1.293-1.392M20 19.75v-2.5c0-.749-.108-1.255-.269-1.602a1.48 1.48 0 0 0-.66-.709c-.31-.17-.731-.286-1.301-.354-.569-.069-1.236-.085-2.02-.085-1.605 0-2.655.098-3.315.467-.296.166-.513.39-.667.718-.161.344-.268.84-.268 1.565v2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.25 8a2.5 2.5 0 1 1 .423-2.119 5.5 5.5 0 0 1 .956-1.523 4 4 0 1 0-1.085 5.42A5.5 5.5 0 0 1 10.25 8m1.655 3.942c-.45-.182-.944-.285-1.456-.347-.664-.08-1.409-.095-2.199-.095-1.543 0-2.993.069-4.047.658A3.03 3.03 0 0 0 2.91 13.55c-.285.608-.409 1.342-.409 2.2V19a.75.75 0 0 0 .75.75H8.5v-1.5H4v-2.5c0-.725.107-1.22.268-1.565.154-.329.371-.552.668-.718C5.595 13.098 6.645 13 8.25 13c.669 0 1.253.012 1.763.058q.432-.415.958-.709.447-.248.934-.407"
  }));
}

export { TeamsIcon };
